// Job Edit Form Controller
// Handles conditional field display and interactions in the job edit form

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "otherTopicField",
    "platformField",
    "outcomeField",
  ];

  connect() {
    console.log("JobEditFormController connected");
    this.setupInitialState();
  }

  setupInitialState() {
    // Set up initial conditional field visibility based on current category
    const categorySelect = this.element.querySelector('select[name="job[job_category]"]');
    if (categorySelect && categorySelect.value) {
      this.updateConditionalFields(categorySelect.value);
    }
  }

  // Handle category change
  handleCategoryChange(event) {
    const category = event.target.value;
    this.updateConditionalFields(category);
  }

  // Update conditional field visibility based on category
  updateConditionalFields(category) {
    // Platform field is only for social_media jobs
    if (this.hasPlatformFieldTarget) {
      const platformContainer = this.platformFieldTarget.closest('.sm\\:col-span-3');
      if (platformContainer) {
        if (category === 'social_media') {
          platformContainer.classList.remove('hidden');
        } else {
          platformContainer.classList.add('hidden');
          // Clear the value when hiding
          const platformSelect = this.platformFieldTarget.querySelector('select');
          if (platformSelect) platformSelect.value = '';
        }
      }
    }

    // Outcome field visibility logic can be added here if needed
    // For now, outcome is shown for all categories
  }

  // Toggle "other topic" text field
  toggleOtherTopic(event) {
    if (!this.hasOtherTopicFieldTarget) return;

    const checkbox = event.target;
    const textField = this.otherTopicFieldTarget;

    if (checkbox.checked) {
      textField.style.display = 'block';
      textField.focus();
    } else {
      textField.style.display = 'none';
      textField.value = '';
    }
  }
}
